<div class="container">
  @if (showPrevButton()) {
    <button
      class="size-s primary no-bg tab-arrow tab-prev prev-button"
      type="button"
      icon="ph-bold ph-caret-left"
      alg-button-icon
      (click)="onPrev()"
    ></button>
  }
  <ng-scrollbar
    class="alg-top-bar-scrollbar"
    trackClass="alg-top-bar-scrollbar-no-track"
    orientation="horizontal"
    [sensorThrottleTime]="1"
    appearance="native"
    >
    <ul class="tabs" [class]="styleClass()" *ngrxLet="tabs$ as tabs">
      @for (tab of tabs; track tab.id) {
        <li class="tabs-item" [class]="tab.styleClass">
          <a class="tabs-item-link" [routerLink]="tab.routerLink" (click)="onChange(tab.id)">{{ tab.label }}</a>
        </li>
      }
    </ul>
  </ng-scrollbar>
  @if (showNextButton()) {
    <button
      class="size-s primary no-bg tab-arrow tab-next next-button"
      type="button"
      icon="ph-bold ph-caret-right"
      alg-button-icon
      (click)="onNext()"
    ></button>
  }
</div>
